import React from 'react';
import { UniqueIdentifier } from '@dnd-kit/core';
import { ITrack } from '../../../../data/models/track';
import { useSortable } from '@dnd-kit/sortable';
import { TimeUtilities } from '../../../common/TimeUtilities';
import { CSS } from '@dnd-kit/utilities';

interface DraggableTrackRowProps {
  id: UniqueIdentifier;
  track: ITrack;
  showShadow: boolean;
}

export function DraggableTrackRow({
  track,
  id,
  showShadow,
}: DraggableTrackRowProps) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr
      ref={setNodeRef}
      className={showShadow ? 'active-row-shadow' : ''}
      style={style}
      {...attributes}
      {...listeners}
    >
      {showShadow ? (
        <td colSpan={7}></td>
      ) : (
        <>
          <td>
            <div className="icon-header-cell">
              <i className="fas fa-grip-vertical fa-lg"></i>
            </div>
          </td>
          <td>{track.trackNumber}</td>
          <td>{track.title}</td>
          <td>{track.version}</td>
          <td>{track.displayArtist}</td>
          <td>{track.isrc}</td>
          <td>{TimeUtilities.convertSecondsToTimeString(track.duration)}</td>
        </>
      )}
    </tr>
  );
}
